/**
 * Generates a Postman collection JSON from the parsed OpenAPI data.
 * @param {object} apiData The API data object from the ApiReference component.
 * @param {string} collectionName The name for the Postman collection.
 * @returns {object} A Postman collection v2.1.0 object.
 */
export const generatePostmanCollectionFromApiData = (apiData, collectionName) => {
  const collection = {
    info: {
      _postman_id: crypto.randomUUID(),
      name: collectionName,
      schema: "https://schema.getpostman.com/json/collection/v2.1.0/collection.json",
    },
    item: [],
  };

  if (apiData && apiData.all) {
    apiData.all.forEach((api) => {
      
      const urlString = api.baseUrl + api.path;
      const url = new URL(urlString.startsWith('https') ? urlString : window.location.origin + urlString);
      // console.log("API:::::::::::::::",api,urlString + api.path,url);

      const postmanRequest = {
        name: api.name,
        request: {
          method: api.method.toUpperCase(),
          header: [],
          url: {
            raw: url.href,
            protocol: url.protocol.replace(/:$/, ""),
            host: url.hostname.split("."),
            path: url.pathname.split("/").filter(Boolean),
            query: [],
          },
          description: api.description,
        },
        response: [],
      };

      // Add headers and query params from parameters
      if (api.parameters) {
        api.parameters.forEach(param => {
          if (param.in === 'header') {
            postmanRequest.request.header.push({
              key: param.name,
              value: `<${param.name}>`,
              type: 'text',
              description: param.description || ''
            });
          } else if (param.in === 'query') {
            postmanRequest.request.url.query.push({
              key: param.name,
              value: `<${param.name}>`,
              description: param.description || ''
            });
          }
        });
      }

      // Add request body
      if (api.requestBody && api.requestBody.example) {
        postmanRequest.request.header.push({
          key: 'Content-Type',
          value: 'application/json',
          type: 'text'
        });
        postmanRequest.request.body = {
          mode: 'raw',
          raw: JSON.stringify(api.requestBody.example, null, 2),
          options: {
            raw: {
              language: 'json'
            }
          }
        };
      }
      if (api.id !== "post-api-security-getaccesstoken") {
          postmanRequest.request.header.push({
            key: 'Authorization',
            value: 'Bearer {{bearerToken}}',
            type: 'text'
          });
        }
      collection.item.push(postmanRequest);
    });
  }

  return collection;
};